import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { BASE_API_URL } from "../../../../../core/environment.tokens";
import { CommentItem } from "../../../../../shared/comments/comment-item/comment-item";
import { EditPendService } from "../../../../../shared/pend/edit-pend.service";
import { IChaseTimelineResponseV1 } from "../../../../../shared/timeline/chase-timeline-item-v1.model";
import { toCommentItems } from "../../../../../shared/timeline/chase-timeline-v1.mapper";
import { createPendAnnotationRequest } from "../create-pend-annotation-request";

@Injectable()
export class InternalPendsDetailCommentsService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private route: ActivatedRoute,
    private editPendService: EditPendService
  ) { }

  getPendGdFromPath(): string {
    return this.route.snapshot.parent.params.pendGd;
  }

  // Reads now go through the V1 chase timeline endpoint so DynamoDB-stored comments (created via
  // React's pend note editor) show up alongside SQL Server comments. Writes still use the legacy
  // endpoint below - see saveComment().
  getComments(): Observable<CommentItem[]> {
    const pendId = this.getPendGdFromPath();

    return this.editPendService.getChasePendData(+pendId).pipe(
      switchMap(chasePend => {
        // This tab shows the full comment history, so request a large pageSize rather than relying
        // on V1's default page size (which is meant for paged UI, not a "show everything" list).
        const url = `${this.baseApiUrl}v1chases/${chasePend.chaseId}/timeline?resources=pend&resourceIds=${pendId}&pageSize=100`;
        return this.http.get<IChaseTimelineResponseV1>(url);
      }),
      map(response => toCommentItems(response && response.items))
    );
  }

  saveComment(commentText: string) {
    const pendId = this.getPendGdFromPath();

    return this.editPendService.getChasePendData(+pendId).pipe(
      switchMap(chasePend => {
        const url = `${this.baseApiUrl}v1chases/${chasePend.chaseId}/annotations`;
        const request = createPendAnnotationRequest(pendId, commentText);

        return this.http.post(url, request);
      }),
      catchError(this.handleError) // then handle the error
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }

    // return an ErrorObservable with a user-facing error message
    return throwError(
      "Something bad happened; please try again later.");
  }


}
